import { Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle'
import { IProfile } from 'interfaces/profiles'
import { Wrapper, Tag, TooltipItem, TooltipTitle } from './styled'

interface IProps {
  items: IProfile[]
}

const Profiles = ({ items }: IProps) => {
  return (
    <>
      {items.length ? (
        <Wrapper>
          {items.slice(0, 2).map((item, index) => (
            <Tooltip
              key={index}
              title={
                <TooltipItem>
                  <FontAwesomeIcon icon={faCircle} />
                  <TooltipTitle>{item.name}</TooltipTitle>
                </TooltipItem>
              }
              placement="top"
            >
              <Tag istotal="false" color={item.color}>
                {item.name}
              </Tag>
            </Tooltip>
          ))}
          {items.length > 2 && (
            <Tooltip
              title={items.slice(2).map((item, index) => (
                <TooltipItem key={index}>
                  <FontAwesomeIcon icon={faCircle} />
                  <TooltipTitle>{item.name}</TooltipTitle>
                </TooltipItem>
              ))}
              placement="top"
            >
              <Tag istotal="true">+{items.length - 2}</Tag>
            </Tooltip>
          )}
        </Wrapper>
      ) : (
        '--'
      )}
    </>
  )
}

export default Profiles
